import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UpcomingFormApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/UpcomingFormApiModel';
import { AvailableFormApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/AvailableFormApiModel';
import { RecentIncidentApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/RecentIncidentApiModel';
import { InProgressFormInstanceApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/InProgressFormInstanceApiModel';
import { InProgressFormInstancesRequestApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/InProgressFormInstancesRequestApiModel';
import { PerformanceDashboardSelectorsApiModel } from '@app/api/api-models/program/performance-evaluation/performance-dashboard/PerformanceDashboardSelectorsApiModel';
import { ProgramRoleApiModel } from '@app/api/api-models/dashboard/ProgramRoleApiModel';
import { HighFiveApiModel } from '@app/api/api-models';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PerformanceDashboardService {
  public apiUrl = 'performance-dashboard';

  constructor(private readonly http: HttpClientService) {}

  public getSelectors(): Observable<PerformanceDashboardSelectorsApiModel> {
    return this.http.get<PerformanceDashboardSelectorsApiModel>(`${this.apiUrl}/selectors`);
  }

  public getUpcomingForms(): Observable<UpcomingFormApiModel[]> {
    return this.http.get<UpcomingFormApiModel[]>(`${this.apiUrl}/upcoming-forms`);
  }

  public getAvailableForms(): Observable<AvailableFormApiModel[]> {
    return this.http.get<AvailableFormApiModel[]>(`${this.apiUrl}/available-forms`);
  }

  public getAvailableSubjects(formId: number): Observable<ProgramRoleApiModel[]> {
    return this.http.get<ProgramRoleApiModel[]>(`${this.apiUrl}/available-subjects/${formId}`);
  }

  public getInProgressFormInstances(
    model: InProgressFormInstancesRequestApiModel
  ): Observable<InProgressFormInstanceApiModel[]> {
    return this.http.get<InProgressFormInstanceApiModel[]>(`${this.apiUrl}/in-progress-form-instances`, {
      params: toQueryParams(model)
    });
  }

  public getRecentIncidents(): Observable<RecentIncidentApiModel[]> {
    return this.http.get<RecentIncidentApiModel[]>(`${this.apiUrl}/recent-incidents`);
  }

  public getRecentHighFives(): Observable<HighFiveApiModel[]> {
    return this.http.get<HighFiveApiModel[]>(`${this.apiUrl}/recent-high-fives`);
  }
}
